import React from "react";

import { EnumWrapper } from "../../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../../utils/enums/enums";

import BasicMemberIdentifierConfigurationFields from "./BasicMemberIdentifierConfigurationFields";

const UniqueNumberConfigurationPage = () => {
  return (
    <div className="sub-content">
      <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
        <BasicMemberIdentifierConfigurationFields />
      </EnumWrapper>
    </div>
  );
};

export default UniqueNumberConfigurationPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/member-identifier-configuration/MemberIdentifierConfigurationPage.js